import { getApiClient } from "@punchup/utils";

const listPath = (listId: string) =>
  `/api/v2/manager/contacts/lists/${encodeURIComponent(listId)}`;

/** Renames one of a manager's imported contact lists. */
export async function renameContactList(
  listId: string,
  name: string
): Promise<void> {
  await getApiClient().patch(listPath(listId), { name });
}

/** Deletes one of a manager's imported contact lists. */
export async function deleteContactList(listId: string): Promise<void> {
  await getApiClient().del(listPath(listId));
}
